import React from "react";
import styles from "./styles.css";
import { BECOME_OWNER } from "./selector";
import LazyImage from "../../shared/lazy-image";
const FranchiseJourneyBecomeOwner = () => {

    return (
        <div styleName={"styles.franchiseJourneyBecomeOwner"}>
            <h2>Journey to become a franchise owner</h2>
            <ul>
                {
                    BECOME_OWNER.map((item, index) => (
                        <li key={index}>
                            <LazyImage src={item.icon} alt={item.title} />
                            <div styleName={"styles.textCard"}>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        </li>
                    )
                    )}
            </ul>
        </div>
    );
};
export default FranchiseJourneyBecomeOwner;

